module.exports = __webpack_public_path__ + "static/logo_sinarmas-light-eee193bd58f1076f40d39fb926ae8100.png";